import React from "react";
import PracticsQuestionTopics from "../../../topics/PracticsQuestionTopics";


function PracticeQuestionsPhysTopics() {



  return (
    <>

      <PracticsQuestionTopics subject="physics" type="dpp" />

    </>
  );
}

export default PracticeQuestionsPhysTopics;